// extracted by mini-css-extract-plugin
export var formContainer = "_eb-0";
export var message = "_eb-1";